import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserService} from '@core/services/user.service';
import {tap} from 'rxjs/operators';
import {environment} from '@env';
import {ROLE_ID_KEYS} from '@core/enums';
import {
  ChangePassword,
  Code,
  ConfirmCode,
  Credentials,
  ErrorInterface,
  ForgotPassword,
  UserAuth,
  UserLogin,
  Success
} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) {
  }

  public login(credentials: Credentials): Observable<UserLogin> {
    credentials.is_host = true;
    return this.http.post<UserLogin>(`${environment.apiUrl}auth/login`, credentials)
      .pipe(tap(this.persistToStorage.bind(this)));
  }

  public sendToEmail(userData: { email: string, id?: string }): Observable<ForgotPassword | UserAuth[]> {
    return this.http.post<ForgotPassword | UserAuth[]>(`${environment.apiUrl}forget-password`, userData);
  }

  public confirmCode(id: string, code: Code): Observable<ConfirmCode> {
    return this.http.post<ConfirmCode>(`${environment.apiUrl}forget-password/${id}`, code);
  }

  public changePassword(data: ChangePassword): Observable<Success> {
    return this.http.patch<Success>(`${environment.apiUrl}change-password`, data);
  }

  public changeCurrentPassword(data: ChangePassword): Observable<Success> {
    return this.http.patch<Success>(`${environment.apiUrl}change-password/v2`, data);
  }

  public persistToStorage(res: UserLogin): UserLogin | ErrorInterface {
    this.userService.user = {
      user_id: res.user_id,
      manager_id: res.manager_id,
      role_id: res.user_type_id,
      role: ROLE_ID_KEYS.get(res.user_type_id),
      username: res.username,
      image: res.image,
      created_at: res.createdate
    };
    this.userService.accessToken = res.access_token;
    return res;
  }
}
